import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ItemAccessDialogComponent } from 'src/app/dialogs/item/item-access-dialog/item-access-dialog.component';
import { CNItem } from 'src/app/models/cnitem';
import { CNReport } from 'src/app/models/cnreport';
import { PatientService } from 'src/app/services/patient.service';
import { ReportService } from 'src/app/services/report.service';

declare var Ext: any;

@Component({
  selector: 'app-report-row-icons',
  templateUrl: './report-row-icons.component.html',
  styleUrls: ['./report-row-icons.component.scss']
})
export class ReportRowIconsComponent implements OnInit {

  public validatedTooltip = '';
  public report: CNReport;

  constructor(private dialog: MatDialog, private patient: PatientService, private ngZone: NgZone,
              private reports: ReportService) { }

  ngOnInit(): void {
  }

  @Input() set item(theReport: CNReport) {
    this.report = theReport;
    if (this.report.validated) {
      // Build validated tooltip
      this.buildValidatedTooltip();
    }
  }

  private buildValidatedTooltip(): void {
//    $validatorUser = new UserID($ReportProperties["ValidatedUserID"]);
//    $validatorSummary = "Utilisateur : ".$validatorUser->GetUserName();
    this.validatedTooltip = 'Date : ' + this.report.getProperty('ValidatedDate');
    // $validatorSummary .= "<br>Date : ".$ReportProperties["ValidatedDate"];
    // $validatorSummary .= "<br>Heure : ".$ReportProperties["ValidatedTime"];
    // $validatorSummary .= "<br>Source : ".$ReportProperties["ValidatedSource"];
    // $validatorSummary .= "<br>Methode : ".$ReportProperties["ValidatedMethod"];
  }

  editReport() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        // Open old report interface
        const documentWindow = new Ext.CNDocumentWindow({
          patientid: this.patient.patient.id,
          reportid: this.report.id
        });
        documentWindow.on('documentSaved', () => {
          console.log('Report saved');
          setTimeout(() => {
            this.reload();
          });
        });
        documentWindow.show();
      });
    });
  }

  reload() {
    this.ngZone.run(() => {
      this.reports.load();
    });
  }

  openReport() {
    const link = '/SN/StVaast/DocumentFile.php?reportid=' + this.report.id;
    window.open(link, '_report');
  }

  openAccess() {
    const dialogRef = this.dialog.open(ItemAccessDialogComponent, {
      data: {
        item: this.report
      },
      maxWidth: '60%',
      minWidth: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  toggleValidation() {
    this.reports.toggleValidation(this.report).subscribe(report => {
      this.report = report;
      this.validatedTooltip = '';
      if (this.report.validated) {
        this.buildValidatedTooltip();
      }
    });
  }
}
